import {LabelToken} from '@github-ui/label-token'
import {LabelGroup, Stack} from '@primer/react'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import type {PullRequestLabel as Label} from '@github-ui/dotcom-schema/types/pull_requests/v1/labels'
import {useLabels} from './data/use-labels'
import sidebarListStyles from './SidebarActionList.module.css'
import {SkeletonText} from '@primer/react/experimental'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'

export function Labels() {
  const {data, isPending, isError} = useLabels()
  if (isPending && !data) return <SkeletonLabels />
  if (isError && !data) return <span className={sidebarListStyles.emptyState}>Unable to load labels</span>

  const labels = data?.labels
  if (!labels || labels.length === 0) {
    return <span className={sidebarListStyles.emptyState}>None yet</span>
  }
  return <LabelList labels={labels} />
}

function LabelList({labels}: {labels: Label[]}) {
  const {owner, repo} = useRouteParams(pullRequestsLayoutRoute)
  return (
    <LabelGroup>
      {labels.map(label => (
        <LabelRow key={label.id} label={label} owner={owner} repo={repo} />
      ))}
    </LabelGroup>
  )
}

function LabelRow({label, owner, repo}: {label: Label; owner: string; repo: string}) {
  const href = `/${owner}/${repo}/issues?q=${encodeURIComponent(`state:open label:"${label.name}"`)}`
  return (
    <LabelToken
      as="a"
      href={href}
      text={label.name}
      fillColor={`#${label.color}`}
      title={label.description || undefined}
    />
  )
}

function SkeletonLabels() {
  return (
    <Stack direction="horizontal" gap="condensed">
      <span className="sr-only">Loading...</span>
      <SkeletonText width="7ch" />
      <SkeletonText width="10ch" />
      <SkeletonText width="5ch" />
    </Stack>
  )
}
